export default "/_next/static/ec19f387bf918dee148cfbd6fae9308b.png";